
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/patients",
      function () {
        return require("private-next-pages/patients/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/patients"])
      });
    }
  